class VerticalResponsive {
    /**
     * The VerticalResponsive class provides an interface for the modal library we use.
     * An instance of VerticalResponsive has open and close functions
     * @param  {object} config contains properties for isMobile, $slideshow, and slideNumberParam
     * @return {obj} instance of VerticalResponsive
     */
    constructor(config) {
        this.$parentContainer = $(config.parentContainer);
        this.className = config.className;
        const viewportHeight = $(window).height();
        this.$elsToMakeVerticallyResponsive = this.$parentContainer.find(`.${this.className}`);
        this.imagesMaxHeight = viewportHeight * 0.6;
    }

    adjustStyles() {
        this.$elsToMakeVerticallyResponsive.each(function compareToParent(i, el) {
            let $el = $(el);
            let $parent = $el.parent();
            let innerElWidth = $el.data('width');
            let innerElHeight = $el.data('height');
            let parentWidth = $parent.width();

            if (innerElWidth >= parentWidth || this.imagesMaxHeight >= innerElHeight) {
                $el.css({ 'width': '100%' });
            }

            if (innerElWidth < parentWidth || this.imagesMaxHeight < innerElHeight) {
                $el.css({'width': 'auto'});
            }

        }.bind(this));
    }

    off() {
        const myProperties = Object.getOwnPropertyNames(this);
        myProperties.forEach((prop) => {
            this[prop] = null;
        });
    }


}

export default VerticalResponsive;
